var map = {
	"./app.json": 161,
	"./blog.json": 162,
	"./components.json": 163,
	"./conversionTable.json": 164,
	"./events.json": 165,
	"./form.json": 166,
	"./glossary.json": 167,
	"./home.json": 168,
	"./iframe.json": 169,
	"./login.json": 170,
	"./logout.json": 171,
	"./menu.json": 172,
	"./news.json": 173,
	"./notifications.json": 174,
	"./pages.json": 175,
	"./profile.json": 176,
	"./ranking-BKP.json": 177,
	"./ranking.json": 178,
	"./register.json": 179,
	"./support.json": 180,
	"./translation.json": 181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;